/* 随机线条 */
import { Canvas, dep, DisplayObject, Filter, getDefaults } from '@tencent/alloy-renderer';
import { PresetSubtype } from '@tencent/slide-sdk-model';
import { AnimFilters, Action } from '../../anim-constants';
import { IAnimFilterOptions } from '../../anim-interface';

// 线条粗细
// TODO: 可以根据元素宽高适当增加线条宽度，
const LINE_HEAVY = 1;

export default class RandomBarsFilter extends Filter {
    public static defaults: IAnimFilterOptions = {
        rate: 0,
        direction: PresetSubtype.Across,
        action: Action.ENTR,
    };

    @dep public rate: number;
    @dep public direction = PresetSubtype.Across;
    @dep public action = Action.ENTR;

    public forbidWebgl = true;
    public type = AnimFilters.RANDOMBAR;
    // 使用 action 和 direction 作为键值，避免在动画面板中更新属性后线条缺失无法覆盖整个元素区域
    protected lineGroupCache: Map<string, number[]>;

    public constructor(options: Partial<IAnimFilterOptions>) {
        super();
        const defaults = getDefaults<typeof RandomBarsFilter>(this);
        this.rate = options.rate ?? defaults.rate;
        this.direction = options.direction ?? defaults.direction;
        this.action = options.action ?? defaults.action;
        this.lineGroupCache = new Map();
    }

    public apply(obj: DisplayObject, canvas: Canvas) {
        this.direction === PresetSubtype.Across ? this.applyHorizon(canvas) : this.applyVertical(canvas);
    }


    /**
     * 水平随机线条
     * @param canvas Canvas
     */
    protected applyHorizon = (canvas: Canvas) => {
        const { width, height } = canvas;
        const { x, y } = canvas.bounds;
        const bars = this.genLineGroup(y, height / LINE_HEAVY);
        const barLen = bars.length;
        const range = barLen * this.rate;
        const renderLines = this.isEntr() ? bars.slice(range, barLen) : bars.slice(0, range);
        renderLines.forEach((line) => {
            canvas.clearRect(x, line, width, LINE_HEAVY);
        });
    };

    /**
     * 垂直随机线条
     * @param canvas Canvas
     */
    protected applyVertical = (canvas: Canvas) => {
        const { width, height } = canvas;
        const { x, y } = canvas.bounds;
        const bars = this.genLineGroup(x, width / LINE_HEAVY);
        const barLen = bars.length;
        const range = barLen * this.rate;
        const renderLines = this.isEntr() ? bars.slice(range, barLen) : bars.slice(0, range);
        renderLines.forEach((line) => {
            canvas.clearRect(line, y, LINE_HEAVY, height);
        });
    };

    /**
     *
     * @param 开始位置 传入长度或者宽度
     * @returns 一个打乱顺序的数组
     */
    protected genLineGroup = (start: number, len: number): number[] => {
        const cacheKey = `${this.action}-${this.direction}`;
        const lines = this.lineGroupCache.get(cacheKey);
        if (lines?.length) return lines;
        const group =  new Array(len).fill(0)
            .map((_, i) => start + (i * LINE_HEAVY));

        for (let i = group.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [group[i], group[j]] = [group[j], group[i]];
        }
        this.lineGroupCache.set(cacheKey, group);
        return group;
    };

    protected  isEntr = () => this.action === Action.ENTR;
}
